export default __webpack_public_path__ + "static/portrait-8364b83a28c4e87b27b9cd9e613b57d6.png";